import { NavLink, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  ListChecks,
  Sparkles,
  SlidersHorizontal,
  CalendarDays,
  Settings,
  Wallet,
} from "lucide-react";

const NAV = [
  { to: "/", label: "Tableau de bord", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/abonnements", label: "Mes abonnements", icon: ListChecks, testid: "nav-subscriptions" },
  { to: "/economies", label: "Mes économies", icon: Sparkles, testid: "nav-savings" },
  { to: "/simulateur", label: "Simulateur", icon: SlidersHorizontal, testid: "nav-simulator" },
  { to: "/calendrier", label: "Calendrier", icon: CalendarDays, testid: "nav-calendar" },
  { to: "/parametres", label: "Paramètres", icon: Settings, testid: "nav-settings" },
];

export default function Sidebar() {
  const location = useLocation();
  return (
    <aside className="hidden lg:flex lg:w-64 flex-col border-r border-gray-100 bg-white sticky top-0 h-screen">
      <div className="px-6 py-7 flex items-center gap-2">
        <div className="h-9 w-9 rounded-xl bg-emerald-600 flex items-center justify-center">
          <Wallet className="text-white" size={18} strokeWidth={2} />
        </div>
        <div className="font-heading text-xl font-bold text-gray-900 tracking-tight">SubSave</div>
      </div>
      <nav className="flex-1 px-3 pb-6 subtle-scroll overflow-y-auto">
        <div className="px-3 pt-2 pb-3 text-[11px] font-bold uppercase tracking-[0.2em] text-gray-400">
          Menu
        </div>
        {NAV.map((item) => {
          const Icon = item.icon;
          const active = location.pathname === item.to;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testid}
              className={`group flex items-center gap-3 px-3 py-2.5 rounded-xl mb-1 text-sm transition-colors duration-150 ${
                active
                  ? "bg-emerald-50 text-emerald-900 font-semibold"
                  : "text-gray-600 hover:bg-gray-50"
              }`}
            >
              <Icon size={18} strokeWidth={1.75} className={active ? "text-emerald-600" : "text-gray-500"} />
              <span>{item.label}</span>
              {active && <span className="ml-auto h-1.5 w-1.5 rounded-full bg-emerald-500" />}
            </NavLink>
          );
        })}
      </nav>
      <div className="px-5 py-5 border-t border-gray-100">
        <div className="rounded-2xl p-4 bg-gradient-to-br from-emerald-50 to-white border border-emerald-100">
          <div className="font-heading text-sm font-bold text-emerald-900 mb-1">Astuce</div>
          <div className="text-xs text-gray-600 leading-relaxed">
            Ajoutez tous vos abonnements pour obtenir des recommandations personnalisées.
          </div>
        </div>
      </div>
    </aside>
  );
}

export function MobileNav() {
  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/90 backdrop-blur-xl border-t border-gray-100">
      <div className="flex justify-around items-center py-2">
        {NAV.slice(0, 5).map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`${item.testid}-mobile`}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 px-3 py-1.5 rounded-lg text-[10px] ${
                  isActive ? "text-emerald-600 font-semibold" : "text-gray-500"
                }`
              }
            >
              <Icon size={20} strokeWidth={1.75} />
              <span className="truncate max-w-[64px]">{item.label.split(" ")[0]}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
